const BaseComponent = require('base/base-component');

class TopLine extends BaseComponent {
  init () {
    let $time = $('.js-thisTime');
    let timeWord = '';
    let curDate = new Date();
    let curHours = curDate.getHours();
    if (curHours < 12) {
      timeWord = '上午好';
    } else if (curHours < 18) {
      timeWord = '下午好';
    } else {
      timeWord = '晚上好';
    }
    $time.html(timeWord);
  }
}
module.exports = TopLine;
